/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Organizationteams2Inputs */

const zh_settingsnav_organizationteams2 = /** @type {(inputs: Settingsnav_Organizationteams2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织与团队`)
};

const en_settingsnav_organizationteams2 = /** @type {(inputs: Settingsnav_Organizationteams2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization & Teams`)
};

const es_settingsnav_organizationteams2 = /** @type {(inputs: Settingsnav_Organizationteams2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización y equipos`)
};

/**
* | output |
* | --- |
* | "Organization & Teams" |
*
* @param {Settingsnav_Organizationteams2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_organizationteams2 = /** @type {((inputs?: Settingsnav_Organizationteams2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Organizationteams2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_organizationteams2(inputs)
	if (locale === "en") return en_settingsnav_organizationteams2(inputs)
	return es_settingsnav_organizationteams2(inputs)
});
export { settingsnav_organizationteams2 as "settingsNav_organizationTeams" }